import React from "react";
import InfoIcon from "../InfoIcon";
import "./index.css";
import { useTranslation } from "react-i18next";

const SubItem = ({ label, value, scopes }) => (
  <div className="subitem">
    <span className="subitemspan">
      {label ? `${value} ${label}` : value}
      {scopes && (
        <div className="scopes">
          {scopes.map((scope, scopeIndex) => (
            <span key={scopeIndex} className="scope">
              {scope}
            </span>
          ))}
        </div>
      )}
    </span>
  </div>
);

const TotalBox = ({ title, items, showInfoIcon, infoText, infoText1 }) => (
  <div className="total-box">
    <div className="total-title">
      <h3>{title}</h3>
    </div>
    <div style={{ display: "flex", justifyContent: "center" }}>
      {items.map((item, index) => (
        <div key={index} className="item">
          {item.subtitle ? (
            <div style={{ display: "flex", flexDirection: "column" }}>
              <div className="sub-item">
                <h4>{item.subtitle}</h4>
                {showInfoIcon && (
                  <InfoIcon text={index === 0 ? infoText : infoText1} />
                )}
              </div>
              <div className="subitem-box">
                {item.subitems.map((subitem, subIndex) => (
                  <SubItem key={subIndex} {...subitem} />
                ))}
              </div>
            </div>
          ) : (
            <SubItem {...item} />
          )}
        </div>
      ))}
    </div>
  </div>
);

const RightBox = ({ totals, lastUpdated }) => {
  const { t } = useTranslation();
  return (
    <div className="right-box">
      <div style={{ display: "flex", width: "100%" }}>
        {totals.map((total, index) => (
          <TotalBox key={index} {...total} />
        ))}
      </div>
      {lastUpdated && (
        <p className="last-updated">
          {t("LAST_UPDATED")}: {lastUpdated}
        </p>
      )}
    </div>
  );
};

export default RightBox;
